import { PublicApiClient } from "../../apiClient/publicApiClient";

export interface UserDetails {
    userId: string | null;
    salutation: "1" | "2" | null;
    title: string | null;
    firstname: string | null;
    surname: string | null;
    email: string | null;
    phone: string | null;
    fax: string | null;
    position: string | null;
    language: string | null;
    customerNo: string | null;
    company: string | null;
    street: string | null;
    zipCode: string | null;
    city: string | null;
    state: string | null;
    country: string | null; // ISO 3166-1 alpha-2 country code e.g. "DE" for Germany
    status: string | null; // e.g. "activated"
    customerAdmin: string | null; // "true" if the user is a customer admin
    userRoles: string[] | null; // e.g. ["customer", "service_read"]
}

export const getUserDetails = async (apiClient: PublicApiClient): Promise<UserDetails> => {
    return apiClient.request<UserDetails>("/user/getuserdetails", {
        mockResponse: mockUserDetails
    });
};

export const mockUserDetails: UserDetails = {
    userId: "ServiceDE",
    salutation: "2",
    title: null,
    firstname: "Marc",
    surname: "Wenzler",
    email: "Marc.Wenzler.DEMO_TWDE1@de.trumpf.com",
    phone: "+49715630334317",
    fax: null,
    position: "Testuser Service App deutsch",
    language: "de",
    customerNo: "270763",
    company: "MyTRUMPF DEMO DE",
    street: "Johann-Maus-Straße 2",
    zipCode: "71254",
    city: "Ditzingen",
    state: null,
    country: "DE",
    status: "Activated",
    customerAdmin: "false",
    userRoles: ["confirmed", "service_full", "order_use", "order_read", "service_read", "order_full", "customer"]
};
